import {
  SURVEY_START_PENDING,
  SURVEY_START_FAILED,
  SURVEY_START_FULFILLED,
  PROCESS_SURVEY_PENDING,
  PROCESS_SURVEY_FAILED,
  PROCESS_SURVEY_FULFILLED,
  SURVEY_RATING,
  SURVEY_EXPERIENCE,
  IS_SURVEY_HIDDEN,
  CLEAR_SURVEY_DATA,
} from "constants-lib/actionTypes"

const initialState = {
  surveyStartStatus: "",
  processSurveyStatus: "",
  rating: 0,
  surveyExperience: "",
  isSurveyHidden: false,
}
export default (state = initialState, action) => {
  switch (action.type) {
    case SURVEY_START_PENDING: {
      return {
        ...state,
        surveyStartStatus: "pending",
      }
    }

    case SURVEY_START_FAILED: {
      return {
        ...state,
        surveyStartStatus: "failed",
      }
    }

    case SURVEY_START_FULFILLED: {
      return {
        ...state,
        surveyStartStatus: "fulfilled",
        surveyResponse: action.payload,
      }
    }

    case PROCESS_SURVEY_PENDING: {
      return {
        ...state,
        processSurveyStatus: "pending",
      }
    }

    case PROCESS_SURVEY_FAILED: {
      return {
        ...state,
        processSurveyStatus: "failed",
        processSurveyResponse: action.payload,
      }
    }

    case PROCESS_SURVEY_FULFILLED: {
      return {
        ...state,
        processSurveyStatus: "fulfilled",
        processSurveyResponse: action.payload,
      }
    }

    case SURVEY_RATING: {
      return {
        ...state,
        rating: action.payload,
      }
    }

    case SURVEY_EXPERIENCE: {
      return {
        ...state,
        surveyExperience: action.payload,
      }
    }

    case IS_SURVEY_HIDDEN: {
      return {
        ...state,
        isSurveyHidden: action.payload,
      }
    }

    case CLEAR_SURVEY_DATA: {
      return {
        ...initialState,
      }
    }

    default:
      return state
  }
}
